import {
    appendSVGBtn,
    replaceHashLinks,
    initResponsiveTables,
    slideToggle,
    headeraddClass,
} from '@js/common/all-functions.js';
import {
    initAOS,
} from '@js/common/aos.js';
import deviceMenu from '@js/common/deviceMenu.js';

deviceMenu();
initAOS();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Buttons arrow start */
    document.querySelectorAll('.btn, .btn-link').forEach(function(element) {
        if (element.classList.contains('btn')) {
            // ----- Ensure span wrapper for icons -----
            let iconsWrapper = element.querySelector('span.btn-icons');
            if (!iconsWrapper) {
                iconsWrapper = document.createElement('span');
                iconsWrapper.classList.add('btn-icons');
                element.appendChild(iconsWrapper);
            }

            // ----- Ensure PREPEND <i> -----
            let firstIcon = iconsWrapper.querySelector('i.icon.first');
            if (!firstIcon) {
                firstIcon = document.createElement('i');
                firstIcon.classList.add('icon', 'first');
                iconsWrapper.insertBefore(firstIcon, iconsWrapper.firstChild);
            }
            appendSVGBtn(firstIcon, '#icon-btn-arrow', '20', '12');

            // ----- Ensure APPEND <i> -----
            let lastIcon = iconsWrapper.querySelector('i.icon.last');
            if (!lastIcon) {
                lastIcon = document.createElement('i');
                lastIcon.classList.add('icon', 'last');
                iconsWrapper.appendChild(lastIcon);
            }
            appendSVGBtn(lastIcon, '#icon-btn-arrow', '20', '12');

        } else if (element.classList.contains('btn-link')) {
            // For .btn-link → just append icon directly
            let linkIcon = element.querySelector('i.icon');
            if (!linkIcon) {
                linkIcon = document.createElement('i');
                linkIcon.classList.add('icon');
                element.appendChild(linkIcon);
            }
            appendSVGBtn(linkIcon, '#icon-btn-arrow', '20', '12');
        }
    });
    // Social Icon
    document.querySelectorAll('a').forEach(function(element) {
        if (element.classList.contains('heateor_sss_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin', '24', '24');
        } else if (element.classList.contains('heateor_sss_button_x')) {
            appendSVGBtn(element, '#icon-x', '24', '24');
        } else if (element.classList.contains('heateor_sss_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '24', '24');
        } else if (element.classList.contains('heateor_sss_more')) {
            appendSVGBtn(element, '#icon-more', '24', '24');
        } else if (element.classList.contains('btn-download')) {
            appendSVGBtn(element.querySelector('.icon'), '#icon-download', '24', '24');
        }
    });

    document.querySelectorAll('.post-detail-body .heateor_sss_sharing_ul > a').forEach(function(el) {
        el.removeAttribute('style');
    });

    /* Buttons arrow End */

    /* Show search bar on click start */
    const searchButton = document.querySelector('header.main-header .header-search .header-search-btn');
    const searchWrap = searchButton.parentNode.querySelector('.h-search-wrap');
    const body = document.body;

    searchButton.addEventListener('click', function() {
        this.classList.toggle('is-click');
        searchWrap.classList.toggle('is-open');
        body.classList.toggle('scroll-fixed');

        setTimeout(() => {
            const searchInput = this.parentElement.querySelector('input[type="search"]');
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    });

    // Hide search bar on click
    const overlay = document.querySelector('header.main-header .header-search .h-search-overlay');
    const closeButton = document.querySelector('header.main-header .header-search .h-search-close');

    function closeSearchPanel() {
        searchButton.classList.remove('is-click');
        searchWrap.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    }

    if (overlay) {
        overlay.addEventListener('click', closeSearchPanel);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPanel);
    }
    /* Show search bar on click end */

    // Header menu start
    if (window.innerWidth >= 991) {
        const megaMenus = document.querySelectorAll('.main-header .menu > li.menu-v2');

        megaMenus.forEach(function(megaMenu) {
            const thisHeight = megaMenu.querySelector('ul.sub-menu') ?.offsetHeight || 0;
            const menuItems = megaMenu.querySelectorAll('ul.sub-menu > li > ul.sub-menu');

            // Find the maximum height among submenus
            let maxHeight = 0;
            menuItems.forEach(function(submenu) {
                const itemHeight = submenu.offsetHeight;
                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                }
            });

            // Set the CSS variable --minHeight accordingly
            if (menuItems.length > 0) {
                const minHeight = maxHeight >= thisHeight ? maxHeight + 'px' : '100%';
                megaMenu.style.setProperty('--minHeight', minHeight);
            }

            // Handle hover for dropdown-menu items inside each megaMenu
            const dropdownItems = megaMenu.querySelectorAll('ul.sub-menu > li.menu-item-has-children');

            dropdownItems.forEach(function(item) {
                item.addEventListener('mouseenter', function() {
                    megaMenu.classList.add('center-menu');
                });
                item.addEventListener('mouseleave', function() {
                    megaMenu.classList.remove('center-menu');
                });
            });
        });
    }
    // Header menu end

    // Footer
    const footerLinks = document.querySelectorAll('.main-footer ul.menu > li.menu-item-has-children > a');

    footerLinks.forEach(link => {
        if (!link.querySelector('.down-arrow')) {
            const span = document.createElement('span');
            span.className = 'down-arrow';

            // Wrap the <a> tag and .down-arrow in a new div with class 'menu-item-wrap'
            const menuItemWrap = document.createElement('div');
            menuItemWrap.className = 'menu-item-wrap';
            link.parentNode.insertBefore(menuItemWrap, link);
            menuItemWrap.appendChild(link);
            menuItemWrap.appendChild(span);
        }
    });

    footerLinks.forEach(link => {
        // Add event listener to the down-arrow to toggle the submenu
        const downArrow = link.parentNode.querySelector('.down-arrow');
        if (downArrow) {
            downArrow.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the click event from triggering the link's click handler
                const menuItem = link.closest('.menu-item');
                const subMenu = menuItem.querySelector('.sub-menu');

                // Toggle active class and slideUp/slideDown for submenu visibility
                if (subMenu) {
                    menuItem.classList.toggle('is-active');
                    slideToggle(subMenu); // Slide down if active
                }
            });
        }
    });

    /************************************
	 ******** All Function Start *********
	 ************************************/
    initResponsiveTables();
    headeraddClass();

    /* Menu Link change "#" to "javascript:void(0);" start */
    replaceHashLinks('header.main-header ul.menu > li');
    replaceHashLinks('footer.main-footer ul.menu > li');
    /* Menu Link change "#" to "javascript:void(0);" end */
    /***********************************
	 ******** All Function End **********
	 ************************************/

});

/* Use jQuery code Start
------------------------------------------------------------------------------*/
(function($) {
    /* Tab outline start */
    $(document).on('keyup', 'a, button', function(e) {
        $(this).each(function() {
            if (e.key === 'Tab' || e.keyCode === 9) {
                if (!$(this).parents('nav').length) {
                    $('.menu-focus').removeClass('menu-focus');
                }
                $('.tab-outline').removeClass('tab-outline');
                $(this).addClass('tab-outline');
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this).parent().addClass('menu-focus').siblings().removeClass('menu-focus');
                } else {
                    if (!$(this).parents('.menu-item-has-children').hasClass('menu-focus')) {
                        $('.menu-focus').removeClass('menu-focus');
                    }
                }
            }
        });
    });

    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.is-click').removeClass('is-click');
            $('.is-open').removeClass('is-open');
            $('.scroll-fixed').removeClass('scroll-fixed');
            $('.is-active').removeClass('is-active');
        }
    });

    $(document).on('click', function() {
        $('.tab-outline').removeClass('tab-outline');
        $('.menu-focus').removeClass('menu-focus');
    });
    /* Tab outline end */
})(jQuery);
/* Use jQuery code End */
